<!--suppress ALL -->

<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản chờ ban hành
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class="leftSection">
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenDialogCreate = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-plus"></i>
                      <span>&nbsp;&nbsp;THÊM MỚI</span>
                    </div>
                  </el-button>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @search="isOpenAdvanceSearchDialog = true"
                  @simpleSearch="simpleSearch"
                >
                  <template #quickFilter>
                    <div
                      class="
                        flex-row
                        flex-left__top
                        margin-right-10
                        custom-label__input
                      "
                    >
                      <span
                        style="margin-top: 0px"
                        class="label-input width__auto"
                        >Ban hành nội bộ
                      </span>
                      <el-checkbox
                        class="
                          style-fullWidth
                          input-border__bottom input-border__radius__0
                          bg__transparent
                        "
                        v-model="inPublisher"
                        @change="filterByTypePublisher"
                      ></el-checkbox>
                    </div>
                    <div
                      class="
                        flex-row
                        flex-left__top
                        margin-right-10
                        custom-label__input
                      "
                    >
                      <span
                        style="margin-top: 0px"
                        class="label-input width__auto"
                        >Ban hành ra ngoài
                      </span>
                      <el-checkbox
                        class="
                          style-fullWidth
                          input-border__bottom input-border__radius__0
                          bg__transparent
                        "
                        v-model="outPublisher"
                        @change="filterByTypePublisher"
                      ></el-checkbox>
                    </div>
                    <div
                      class="
                        flex-row
                        flex-left__top
                        margin-right-10
                        custom-label__input
                        fix-width__large
                      "
                    >
                      <span class="label-input width__auto"
                        >Ngày ký duyệt:</span
                      >
                      <el-date-picker
                        v-model="signerTimeRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="
                          style-fullWidth
                          input-border__bottom input-border__radius__0
                          bg__transparent
                        "
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="center"
                        :clearable="false"
                        @change="filterBySignerTimeRange"
                      >
                      </el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <chobanhanh-advance-search
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list vb-cho-banhanh-index">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <!-- <div class="leftSection flex-row flex__left"> -->
                <div class="theTitle theTitle__lv5 flex-row flex__center">
                  STT
                </div>
                <div
                  class="theTitle theTitle__lv1 flex-row flex__left clickable"
                  @click="doSort('quote')"
                >
                  Trích yếu
                  <sort-caret :order="order" :sort="sort" :field="'quote'" />
                </div>
                <!-- </div>
                <div class="rightSection flex-row flex__right"> -->
                <div
                  class="theTitle theTitle__lv2 flex-row flex__left clickable"
                  @click="doSort('signerName')"
                >
                  Người ký duyệt
                  <sort-caret
                    :order="order"
                    :sort="sort"
                    :field="'signerName'"
                  />
                </div>
                <div
                  class="theTitle theTitle__lv3 flex-row flex__left clickable"
                  @click="doSort('signerTime')"
                >
                  Thời gian ký duyệt
                  <sort-caret
                    :order="order"
                    :sort="sort"
                    :field="'signerTime'"
                  />
                </div>
                <!-- </div> -->
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in outgoingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between clickable"
                    @click="viewDetailDocs(item)"
                  >
                    <!-- <div class="leftSection flex-row flex__left"> -->
                    <div class="theTitle__lv5">
                      <div class="flex-row flex__center">
                        <div class="section-check flex-row flex__center">
                          {{ $itemIndex + 1 }}
                        </div>
                        <i
                          class="fas fa-file color__silver"
                          @click.stop="
                            downloadAttachment(
                              item,
                              ATTACHMENT_OBJECT_TYPE.VB_DI
                            )
                          "
                        ></i>
                      </div>
                    </div>
                    <div class="theTitle__lv1 margin-right-10">
                      <div class="title-docs flex-col flex__left">
                        <div class="tt_1 clickable">{{ item.quote }}</div>
                        <div class="tt_2 flex-row flex__left">
                          <span v-if="item.docCode"
                            >#{{ item.docCode }}&nbsp;&nbsp;</span
                          >
                          <el-tag
                            v-if="item.docTypeName"
                            size="mini"
                            :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                          </el-tag>

                          <el-tag
                            v-if="isShowPiority(item.priorityId)"
                            size="mini"
                            :class="[
                              'priority',
                              getPiorityClass(item.priorityId),
                            ]"
                          >
                            <i class="fas fa-bolt"></i>
                            <span>
                              {{ item.priorityName }}
                            </span>
                          </el-tag>
                        </div>
                      </div>
                    </div>
                    <!-- </div>
                    <div class="rightSection flex-row flex__right"> -->
                    <div
                      class="theTitle__lv2 flex-row flex__left font-size__small"
                    >
                      <div class="flex-row flex__left">
                        <displayPeople
                          :name="item.signerName"
                          v-if="item.signerName"
                        />
                        <span v-else>-</span>
                      </div>
                    </div>
                    <!-- </div> -->

                    <!-- <div class="rightSection flex-row flex__right"> -->
                    <div
                      class="theTitle__lv3 flex-row flex__left font-size__small"
                    >
                      <div class="flex-row flex__right">
                        <i class="cellIcon color__silver fas fa-clock"></i>
                        {{
                          item.signerTime | dateFormatter({ nullValue: "-" })
                        }}
                      </div>
                    </div>
                    <!-- </div> -->

                    <div class="theQuickAction flex-row flex__right">
                      <el-tooltip
                        content="Xóa"
                        placement="top"
                        v-if="isEnableDelete(item)"
                      >
                        <i
                          class="
                            action-icon
                            bgAmbient__red
                            clickable
                            fas
                            fa-trash
                          "
                          @click.stop="delete_(item)"
                        ></i>
                      </el-tooltip>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
      <createDialog
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        @closed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @success="createDocSuccess"
      />
      <BHanhDocOutDialog
        :isOpen="isOpenBHanhDocOut"
        :quote="docAfterSave.quote"
        :docId="docAfterSave.id"
        :docStatus="docAfterSave.status"
        :publisherId="docAfterSave.publisherId"
        :docTypeId="docAfterSave.docTypeId"
        :deptEditorId="docAfterSave.deptEditorId"
        :otherReceivePlaces="docAfterSave.otherReceivePlaces"
        :docReceiverIds="docAfterSave.receiveDepartmentIds"
        v-if="isEnableBHanhDocOut"
        @closed="isEnableBHanhDocOut = false"
        @closeDialog="isOpenBHanhDocOut = false"
        @success="banHanhVanThuSuccess"
      />
    </template>
  </listTemplate>
</template>
<script>
import BHanhDocOutDialog from "./components/BHanhDocOutDialog";

import buildShortNameFilter from "../../filters/buildShortNameFilter";
import outGoingDocSevice from "../../services/outgoingDocService";
import dateFormatter from "../../filters/dateFormatter";
import constants from "../../constants";
import utils from "../../services/utils";
import { EventBus } from "../../event-bus.js";
import dateUtils from "../../dateUtils";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import buildAttachmentURL from "../../filters/buildAttachmentURL";
import ChobanhanhAdvanceSearch from "./components/chobanhanh-advance-search";
import handleRequestErrorMixin from "../handleRequestErrorMixin";

export default {
  components: {
    ChobanhanhAdvanceSearch,
    InfiniteLoading: () => import("vue-infinite-loading"),
    createDialog: () => import("./components/CreateKyNgoaiDialog.vue"),
    listTemplate: () => import("../common/list.vue"),
    headerTemplate: () => import("../../components/header/main-header.vue"),
    searchTemplate: () => import("../common/search.vue"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    subHeader: () => import("../../components/main/sub-header.vue"),
    SortCaret: () => import("./SortCaret"),
    displayPeople: () => import("../common/displayPeople.vue"),
    BHanhDocOutDialog,
  },

  mixins: [vbAttachmentTokenMixin, handleRequestErrorMixin],
  filters: { dateFormatter, buildShortNameFilter, buildAttachmentURL },

  data() {
    return {
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,

      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),

      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      perfectScrollbarSetting: { maxScrollbarLength: 350 },

      isOpenBHanhDocOut: false,
      isEnableBHanhDocOut: false,
      docAfterSave: null,

      outgoingDocs: [],

      page: 0,
      size: 10,
      advanceSearchForm: {},
      sort: null,
      order: null,
      keyword: null,
      signerTimeRange: [null, null],
      typePublisher: null,
      inPublisher: false,
      outPublisher: false,
    };
  },

  mounted() {
    EventBus.$on(this.currentRoute, (options) => {
      this.doSearch();
    });
  },

  computed: {
    currentRoute() {
      return this.$route.path.split("/")[3];
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    dateRange() {
      return this.$route.params.dateRange;
    },
  },

  watch: {
    isOpenBHanhDocOut(newValue) {
      newValue && (this.isEnableBHanhDocOut = newValue);
    },

    isOpenDialogCreate: function (newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },
    isOpenAdvanceSearchDialog: function (newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },
  },

  created() {
    this.initQuery();
  },

  methods: {
    isEnableDelete(item) {
      return (
        item &&
        item.isKyNgoai == constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE &&
        item.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH &&
        item.publisherId == this.$store.getters.userDeptRole.deptId &&
        this.$store.getters.userDeptRole.roleCode == constants.ROLE.CODE.VAN_THU
      );
    },

    delete_(item) {
      this.$confirm(`Bạn có muốn xóa văn bản "${item.quote}" ?`, "Thông báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning",
      }).then(() => {
        outGoingDocSevice
          .deleteForVanThu(item.id)
          .then((respone) => {
            this.$message({
              message: "Xóa thành công",
              type: "success",
              duration: 2000,
            });
            this.doSearch();
          })
          .catch((error) => this.commonHandleRequestError(error));
      });
    },

    banHanhVanThuSuccess() {
      this.isOpenBHanhDocOut = false;
      this.doSearch();
    },

    createDocSuccess(event) {
      this.docAfterSave = event.doc;
      this.isOpenDialogCreate = false;
      this.isOpenBHanhDocOut = true;
      this.doSearch();
    },

    initDateRange() {
      this.signerTimeRange =
        (this.dateRange && dateUtils.getDatesByQuickFilter(this.dateRange)) ||
        dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
      this.fromSignerTime = this.signerTimeRange[0].getTime();
      this.toSignerTime = this.signerTimeRange[1].getTime();
    },

    filterByTypePublisher() {
      if (this.inPublisher && !this.outPublisher) {
        this.advanceSearchForm.typePublisher = 1;
      } else if (this.outPublisher && !this.inPublisher) {
        this.advanceSearchForm.typePublisher = 2;
      } else if(this.inPublisher && this.outPublisher) {
        this.advanceSearchForm.typePublisher = null;
      } else {
        this.advanceSearchForm.typePublisher = undefined;
      }
      this.doSearch();
    },

    filterBySignerTimeRange(event) {
      this.advanceSearchForm.fromSignerTime =
        this.signerTimeRange && this.signerTimeRange[0]
          ? this.signerTimeRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toSignerTime =
        this.signerTimeRange && this.signerTimeRange[1]
          ? this.signerTimeRange[1].getTime()
          : undefined;
      this.doSearch();
    },

    initQuery() {
      this.sort = this.$route.query.sort || "updateTime";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        typePublisher: parseInt(this.$route.query.typePublisher) || undefined,
        keyword: this.$route.query.keyword || undefined,
        fromSignerTime: this.$route.query.fromSignerTime
          ? parseInt(this.$route.query.fromSignerTime)
          : undefined,
        toSignerTime: this.$route.query.toSignerTime
          ? parseInt(this.$route.query.toSignerTime)
          : undefined,
        docTypeId: this.$route.query.docTypeId
          ? parseInt(this.$route.query.docTypeId)
          : undefined,
        priorityId: this.$route.query.priorityId
          ? parseInt(this.$route.query.priorityId)
          : undefined,
        quote: this.$route.query.quote || undefined,
        otherReceivePlaces: this.$route.query.otherReceivePlaces || undefined,
        receiveDeptId: this.$route.query.receiveDeptId || undefined,
        fileContent: this.$route.query.fileContent || undefined,
      };
      if (this.advanceSearchForm.typePublisher === 1) {
        this.inPublisher = true;
      } else if (this.advanceSearchForm.typePublisher === 2) {
        this.outPublisher = true;
      } else if (this.$route.query.typePublisher === undefined) {
        this.inPublisher = false;
        this.outPublisher = false;
      } else {
        this.inPublisher = true;
        this.outPublisher = true;
      }
      this.keyword = this.advanceSearchForm.keyword;
      this.initSignerTimeRange();
    },

    buildQuery() {
      return utils.merge(
        { sort: this.sort || "updateTime", order: this.order || "desc" },
        this.advanceSearchForm
      );
    },

    initSignerTimeRange() {
      if (
        this.advanceSearchForm.fromSignerTime ||
        this.advanceSearchForm.toSignerTime
      ) {
        this.signerTimeRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromSignerTime),
          dateUtils.toMoment(this.advanceSearchForm.toSignerTime),
        ];
      } else {
        this.signerTimeRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
        this.advanceSearchForm.fromSignerTime = defaultTimeRange[0];
        this.advanceSearchForm.toSignerTime = defaultTimeRange[1];
      }
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.priorityId = undefined;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.otherReceivePlaces = undefined;
      this.advanceSearchForm.receiveDeptId = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.advanceSearchForm.keyword = undefined;
      this.keyword = null;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.priorityId =
        advanceSearchForm.priorityId || undefined;
      this.advanceSearchForm.docTypeId =
        advanceSearchForm.docTypeId || undefined;
      this.advanceSearchForm.receiveDeptId =
        advanceSearchForm.receiveDeptId || undefined;
      this.advanceSearchForm.otherReceivePlaces =
        advanceSearchForm.otherReceivePlaces || undefined;
      this.advanceSearchForm.fileContent =
        advanceSearchForm.fileContent || undefined;
      this.doSearch();
    },

    doSort(sort) {
      let order =
        sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
      this.sort = sort;
      this.order = order;
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: this.$router.name,
        params: this.$route.params,
        query: this.buildQuery(),
      });

      this.outgoingDocs = [];
      this.page = 0;
      this.$nextTick(() => this.$refs.infiniteLoading.stateChanger.reset());
    },

    infiniteHandler($state) {
      this.list().then((items) => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(","),
      };

      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        status: constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
      });

      return outGoingDocSevice
        .listChoBanHanh2(advanceSearchForm, pageable)
        .then((response) => {
          let items = response.data;
          items && this.outgoingDocs.push(...items);
          return items;
        });
    },

    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPiority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    viewDetailDocs(item) {
      item.isSeen = 1;
      this.$router.push({
        name: "vbChoBanHanhDetail",
        params: { userDeptRoleId: this.userDeptRoleId, id: item.id },
        query: this.$route.query,
      });
    },
  },
};
</script>
<style scoped>
/* Start Responsive 19/05 */
.vb-cho-banhanh-index .theTitle__lv1 {
  width: 32%;
}
.vb-cho-banhanh-index .theTitle__lv2 {
  width: 25%;
}
.vb-cho-banhanh-index .theTitle__lv3 {
  width: 20%;
}
.vb-cho-banhanh-index .theTitle__lv4 {
  width: 10%;
}
.vb-cho-banhanh-index .theTitle__lv5 {
  width: 90px;
}
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/VbChoBanHanhIndex.vue